import { render } from "./AcsBoost.vue?vue&type=template&id=52acdf4a&scoped=true"
import script from "./AcsBoost.vue?vue&type=script&lang=ts"
export * from "./AcsBoost.vue?vue&type=script&lang=ts"

import "./AcsBoost.vue?vue&type=style&index=0&id=52acdf4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52acdf4a"

export default script